// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"fd1858b4","115":"02a97632","164":"7615ffdb","245":"b1feb539","246":"a4508a4f","255":"ad290470","311":"eb274b19","452":"d0c3fa2a","469":"e08da145","531":"6f6f8228","791":"edb0ea2c","844":"aed86a2b"}[chunkId] + ".chunk.js";
};